import { render, staticRenderFns } from "./GratificationsView.vue?vue&type=template&id=352f21aa"
import script from "./GratificationsView.vue?vue&type=script&lang=js"
export * from "./GratificationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports